<template>
  <b-container fluid v-if="customer_behavior_context_loaded">
    <b-row>
      <b-col lg="3" md="6" sm="12" class="p-0" v-for="(item, i) in CustomerBehaviorMetricsObject" :key="'item-' + i">
        <b-container fluid class="pr-2 pb-4 pl-2">
          <card :info="item.info" :title="item.title" :showDiff="item.show_diff">
            <div slot="image" :class="item.bg + ' img-box'">
              <img :src="require(`@/assets/${item.img}`)" alt="img">
            </div>
          </card>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
  <loader-box v-else height="180px" class="mb-4 mr-2 ml-2"/>
</template>

<script>
import Card from '@/components/Card.vue'
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    Card,
    LoaderBox
  },
  computed: {
    customer_behavior_context_loaded() { return this.$store.getters.customer_behavior_context_loaded },
    CustomerBehaviorMetricsObject() { return this.$store.getters.CustomerBehaviorMetricsObject }
  }
}
</script>

<style>
</style>

